export default "__VITE_ASSET__CBEBez1u__"